import { hubspotApi } from "src/services/integrations/hubspot";
import { useQueryBuilder } from "src/query/useBuilders";
import { FETCH, HUBSPOT_PIPELINES } from "src/query/queryKeys";


export const useHubspotPipelinesFetch = (id? : string) => {
  return useQueryBuilder([HUBSPOT_PIPELINES, FETCH], async() => {
    if(!id) return null;
    const data = await hubspotApi.fetchPipelines(id);
    return data;
  }, false, 0, true);
};